// 项目档案存档登记

<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行-项目编号 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>项目编号</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_code}}</span>
      </div>
    </div>
    <!-- 第三行-项目组长 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>项目组长</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_contacts}}</span>
      </div>
    </div>
    <!-- 第四行-存档资料清单 -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_qd@2x.png" alt />
        <span>存档资料清单</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <el-table
        :data="tableData1"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="content" label="清单名称"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="检查" width="220">
          <template slot-scope="scope">
            <div class="auditOpinion" style="display:flex;justify-content: center;">
              <el-radio-group
                v-model="scope.row.radio"
                @change="handleChange"
                :disabled="!isSubmit"
              >
                <el-radio :label="'0'">有</el-radio>
                <el-radio :label="'1'">无</el-radio>
              </el-radio-group>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 第五行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传项目档案存档清单,模板文件：</div>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/项目档案存档清单.doc">项目档案存档清单.doc</a>
      </div>
    </div>
    <!-- 签字 -->
    <!-- <div class="writeName" style="margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:100px">反馈人签字</span>
      <img
        v-if="!addFormData.sign_office"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_office"
        @click="handleReceiverFlag1(addFormData.sign_office)"
        style="width:66px;"
        :src="addFormData.sign_office"
        alt
      />
    </div>-->
    <!-- 日期 -->
    <!-- <div class="rightTimeRow" style="margin-bottom:30px">
      <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
      <span style="color:#333;margin:0 10px">日期</span>
      <el-date-picker
        v-model="addFormData.date"
        :disabled="!isSubmit"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
    </div>-->

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'51'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,

      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      S_project_code: '',
      S_contacts: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      addFormData: {
        file_json: '',

        // sign_office: '',
        // date: '',
        annex: '',
      },
      // 文件上传组件
      detailsImgList: [],
      submitImgList: [],
      // 文件上传组件
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      topBarActive: '1',
      infop: '',
      token: '',
      value: '',
      tableData1: [
        {
          id: 1,
          content: '安全评价合同(复印件)',
          radio: '0',
        },
        {
          id: 2,
          content: '过程控制文件',
          radio: '0',
        },
        {
          id: 3,
          content: '企业安全评价委托书',
          radio: '0',
        },
        {
          id: 4,
          content: '企业现场调查资料及评价人员现场工作影像',
          radio: '0',
        },
        {
          id: 5,
          content: '安全评价报告三审稿(纸质、电子版)',
          radio: '0',
        },
        {
          id: 6,
          content: '客户意见反馈表',
          radio: '0',
        },
        {
          id: 7,
          content: '整改问题清单、企业回复单',
          radio: '0',
        },
        {
          id: 8,
          content: '签字页',
          radio: '0',
        },
        {
          id: 9,
          content: '网上公示材料',
          radio: '0',
        },
        {
          id: 10,
          content: '专家评审意见、企业回复单',
          radio: '0',
        },
      ],
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/file_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.archived_list = JSON.stringify(this.tableData1)
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('archived_list', this.addFormData.archived_list)
        // param.append('sign_office', this.addFormData.sign_office)
        // param.append('date', this.addFormData.date)

        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/file',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('project_id', this.details_project_id)

      if (this.$route.query.is_over == '1') {
        param.append('is_over', '1')
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/file_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      this.S_project_code = res.datas.info.project_code
      this.S_contacts = res.datas.info.evaluators.nickname
      // 判断表格
      if (this.addFormData.archived_list) {
        this.tableData1 = this.addFormData.archived_list
      }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断签名
      // if (
      //   this.addFormData.sign_office == 'undefined' ||
      //   this.addFormData.sign_office == 'null'
      // ) {
      //   this.addFormData.sign_office = ''
      // }
      // 判断时间
      // if (
      //   this.addFormData.date == 'undefined' ||
      //   this.addFormData.date == 'null'
      // ) {
      //   this.addFormData.date = ''
      // }
      //
      this.isComponentsShow = true
      console.log('存档-详情', this.addFormData)
    },
    // 文件上传
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_office = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },

    handleReceiverSign() {},
    // 签名
    handleChange() {
      console.log(this.tableData1)
    },
    handleTopBarClikc(val) {
      this.topBarActive = val
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>